import React, { useEffect } from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { RootStack } from 'navigation/root-stack'
import { _navigationRef } from 'navigation/global'
import { linking } from 'navigation/linking'
import { keyboardStore } from 'store/keyboard'
import { Modal, StatusBar, Text, TouchableOpacity, View } from 'react-native'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { createTheme, ThemeProvider } from '@rneui/themed'
import { IS_DEV } from 'infra/constant'
import NetworkLogger from 'react-native-network-logger'
import { useSafeAreaInsets } from 'infra/util'
import { BaseText } from 'ui/common/text'
import { notifyNavigationReady } from 'bootstrap/navigation-monitoring'

const theme = createTheme({
  lightColors: {
    primary: '#fff',
  },
  darkColors: {
    primary: '#fff',
  },
})

export const App = () => {
  useEffect(() => {
    keyboardStore.sub()
    return () => {
      keyboardStore.unsub()
    }
  }, [])
  return (
    <SafeAreaProvider>
      <ThemeProvider theme={theme}>
        <StatusBar barStyle={'dark-content'} />
        {/* linking: 웹에서만 URL↔화면 동기화 (native 는 undefined — 동작 불변) */}
        <NavigationContainer
          ref={_navigationRef}
          linking={linking}
          onReady={notifyNavigationReady}
        >
          <RootStack />
        </NavigationContainer>
        <NetworkDebugger />
      </ThemeProvider>
    </SafeAreaProvider>
  )
}

const NetworkDebugger = () => {
  const [isShowLogger, setIsShowLogger] = React.useState(false)
  const { top } = useSafeAreaInsets()
  if (!IS_DEV) return null
  return (
    <>
      <TouchableOpacity
        style={{
          position: 'absolute',
          zIndex: 10000,
          bottom: 280,
          right: 20,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          width: 44,
          height: 44,
          borderRadius: 22,
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onPress={() => setIsShowLogger(true)}
      >
        <Text>🐛</Text>
      </TouchableOpacity>
      <Modal
        visible={isShowLogger}
        onRequestClose={() => setIsShowLogger(false)}
      >
        <View style={{ flex: 1, paddingTop: top }}>
          <TouchableOpacity
            onPress={() => setIsShowLogger(false)}
            style={{ alignSelf: 'flex-end', padding: 16 }}
          >
            <BaseText>닫기 ✕</BaseText>
          </TouchableOpacity>
          <NetworkLogger theme='dark' />
        </View>
      </Modal>
    </>
  )
}
